/* eslint-disable */
export default function SvgHelper({ svgName }) {
  switch (svgName) {
    case 'open_sidebar':
      return (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.2422 1.5C6.4432 1.5 1.74219 6.20101 1.74219 12C1.74219 17.799 6.4432 22.5 12.2422 22.5C18.0412 22.5 22.7422 17.799 22.7422 12C22.7422 6.20101 18.0412 1.5 12.2422 1.5ZM0.242188 12C0.242188 5.37258 5.61477 0 12.2422 0C18.8696 0 24.2422 5.37258 24.2422 12C24.2422 18.6274 18.8696 24 12.2422 24C5.61477 24 0.242188 18.6274 0.242188 12ZM8.60942 6.34737C8.83179 5.99791 9.29535 5.89487 9.64482 6.11724L16.9018 10.7348C17.1143 10.8705 17.2892 11.0576 17.4104 11.2787C17.5316 11.4998 17.5951 11.7479 17.5951 12C17.5951 12.2521 17.5316 12.5002 17.4104 12.7213C17.2892 12.9424 17.1143 13.1295 16.9018 13.2652L9.64482 17.8828C9.29535 18.1051 8.83179 18.0021 8.60942 17.6526C8.38706 17.3032 8.49009 16.8396 8.83956 16.6172L16.0946 12.0008L16.0949 11.9995L8.83956 7.38276C8.49009 7.1604 8.38706 6.69684 8.60942 6.34737Z'
            fill='#FBFBFB'
          />
        </svg>
      );
    case 'trash_icon':
      return (
        <svg
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12.5208 15H4.35417C4.04475 15 3.748 14.8771 3.52921 14.6583C3.31042 14.4395 3.1875 14.1428 3.1875 13.8334V3.33337H13.6875V13.8334C13.6875 14.1428 13.5646 14.4395 13.3458 14.6583C13.127 14.8771 12.8302 15 12.5208 15Z'
            stroke='#c3c1da'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6.6875 11.4999V6.83325'
            stroke='#c3c1da'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.1875 11.4999V6.83325'
            stroke='#c3c1da'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.5 3.33337H15.3759'
            stroke='#c3c1da'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.0397 1H6.53971C6.23029 1 5.93355 1.12292 5.71476 1.34171C5.49596 1.5605 5.37305 1.85725 5.37305 2.16667V3.33333H11.2064V2.16667C11.2064 1.85725 11.0835 1.5605 10.8647 1.34171C10.6459 1.12292 10.3491 1 10.0397 1Z'
            stroke='#c3c1da'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'folder_contour':
      return (
        <svg
          width='17'
          height='17'
          viewBox='0 0 16 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            stroke='#424242'
            strokeWidth='0.5'
            d='M6.23203 1.3999L6.76236 0.869572L6.54269 0.649902H6.23203V1.3999ZM7.58203 2.7499L7.0517 3.28023L7.27137 3.4999H7.58203V2.7499ZM1.09219 1.66006L0.561857 1.12973L0.561857 1.12973L1.09219 1.66006ZM5.60003 6.79886C5.18582 6.79886 4.85003 7.13464 4.85003 7.54886C4.85003 7.96307 5.18582 8.29886 5.60003 8.29886V6.79886ZM11.2 7.54886L11.7304 8.07919C12.0233 7.78629 12.0233 7.31142 11.7304 7.01853L11.2 7.54886ZM9.84801 5.13617C9.55512 4.84328 9.08024 4.84328 8.78735 5.13617C8.49446 5.42907 8.49446 5.90394 8.78735 6.19683L9.84801 5.13617ZM8.78735 8.90088C8.49446 9.19377 8.49446 9.66865 8.78735 9.96154C9.08024 10.2544 9.55512 10.2544 9.84801 9.96154L8.78735 8.90088ZM1.73203 2.1499H6.23203V0.649902H1.73203V2.1499ZM5.7017 1.93023L7.0517 3.28023L8.11236 2.21957L6.76236 0.869572L5.7017 1.93023ZM7.58203 3.4999H14.332V1.9999H7.58203V3.4999ZM14.332 3.4999C14.3934 3.4999 14.4137 3.51256 14.4415 3.54039L15.5022 2.47973C15.1832 2.16069 14.777 1.9999 14.332 1.9999V3.4999ZM14.4415 3.54039C14.4694 3.56822 14.482 3.58858 14.482 3.6499H15.982C15.982 3.20498 15.8212 2.79877 15.5022 2.47973L14.4415 3.54039ZM14.482 3.6499V11.7499H15.982V3.6499H14.482ZM14.482 11.7499C14.482 11.8112 14.4694 11.8316 14.4415 11.8594L15.5022 12.9201C15.8212 12.601 15.982 12.1948 15.982 11.7499H14.482ZM14.4415 11.8594C14.4137 11.8873 14.3934 11.8999 14.332 11.8999V13.3999C14.777 13.3999 15.1832 13.2391 15.5022 12.9201L14.4415 11.8594ZM14.332 11.8999H1.73203V13.3999H14.332V11.8999ZM1.73203 11.8999C1.6707 11.8999 1.65035 11.8873 1.62252 11.8594L0.561857 12.9201C0.880899 13.2391 1.28711 13.3999 1.73203 13.3999V11.8999ZM1.62252 11.8594C1.59469 11.8316 1.58203 11.8112 1.58203 11.7499H0.0820312C0.0820312 12.1948 0.242815 12.601 0.561857 12.9201L1.62252 11.8594ZM1.58203 11.7499V2.2999H0.0820312V11.7499H1.58203ZM1.58203 2.2999C1.58203 2.23858 1.59468 2.21822 1.62252 2.19039L0.561857 1.12973C0.242815 1.44877 0.0820312 1.85498 0.0820312 2.2999H1.58203ZM1.62252 2.19039C1.65035 2.16256 1.6707 2.1499 1.73203 2.1499V0.649902C1.28711 0.649902 0.880899 0.810687 0.561857 1.12973L1.62252 2.19039ZM5.60003 8.29886H11.2V6.79886H5.60003V8.29886ZM8.78735 6.19683L10.6697 8.07919L11.7304 7.01853L9.84801 5.13617L8.78735 6.19683ZM10.6697 7.01853L8.78735 8.90088L9.84801 9.96154L11.7304 8.07919L10.6697 7.01853Z'
            fill='#424242'
          />
        </svg>
      );
    case 'combine_icon':
      return (
        <svg
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M5.50625 10.8768L6.99938 12.5999M6.99938 12.5999L8.4925 10.8768M6.99938 12.5999L6.99961 4.83925M6.99961 4.83925C6.99884 4.38471 6.92015 3.93484 6.76808 3.51554C6.61601 3.09624 6.39356 2.7158 6.11354 2.39613C5.83352 2.07646 5.50146 1.82387 5.13649 1.65292C4.77152 1.48196 4.38085 1.39602 3.98698 1.40004H1.40039M6.99961 4.83925C7.00039 4.38471 7.07914 3.93484 7.23121 3.51554C7.38328 3.09624 7.60573 2.7158 7.88575 2.39613C8.16577 2.07646 8.49783 1.82387 8.8628 1.65292C9.22776 1.48196 9.61843 1.39602 10.0123 1.40004H12.6004'
            stroke='#5C5C5C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'unix_time_icon':
      return (
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.10078 4.8498V7.09981L9.91298 9.91261M15.2008 7.99981C15.2008 11.9763 11.9772 15.1998 8.00078 15.1998C4.02433 15.1998 0.800781 11.9763 0.800781 7.99981C0.800781 4.02335 4.02433 0.799805 8.00078 0.799805C11.9772 0.799805 15.2008 4.02335 15.2008 7.99981Z'
            stroke='#5C5C5C'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'plus_add':
      return (
        <svg
          width='15'
          height='15'
          viewBox='0 0 15 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M1 7.24968H13.5M7.25 13.4994V1'
            stroke='#0a0a0a'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'hotglue_upload_icon':
      return (
        <svg
          width='13'
          height='13'
          viewBox='0 0 13 13'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M1.19995 6.1997H11.2M6.19995 11.1994V1.19995'
            stroke='#0D074B'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    case 'logo_icon':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 296 296'>
          <path d='M211,195.29l-23.94-6.82a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59,40.62,40.62,0,0,1-47.47,1.64,40.17,40.17,0,0,1-15-18.59,1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.73,67.73,0,0,0,79.11-2.74,66.92,66.92,0,0,0,23-33.3A1,1,0,0,0,211,195.29Z' />
          <path d='M148,179.11c35.35,0,64-28.45,64-63.55S183.35,52,148,52,84,80.45,84,115.56,112.65,179.11,148,179.11Zm0-98.06a34.51,34.51,0,1,1-34.74,34.51A34.62,34.62,0,0,1,148,81.05Z' />
          <path d='M182.74,115.56a34.59,34.59,0,0,1-30.35,34.22,35.31,35.31,0,0,0,4.39.28,34.51,34.51,0,1,0,0-69,35.31,35.31,0,0,0-4.39.28A34.58,34.58,0,0,1,182.74,115.56Z' />
          <path d='M93.13,201a1,1,0,0,1,.6-1.29l16.71-6c-.27-.6-.53-1.21-.77-1.82a1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.75,67.75,0,0,0,40,11.39c.68,0,1.36-.06,2-.1a67.68,67.68,0,0,1-33.26-11.29A67,67,0,0,1,93.13,201Z' />
          <path d='M187.09,188.47a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59A40.55,40.55,0,0,1,151.66,217a40.08,40.08,0,0,0,5.8.22,40.68,40.68,0,0,0,23.47-8.48,40.11,40.11,0,0,0,13.22-18.27Z' />
          <path d='M148,179.11l4.39-.15c-33.3-2.24-59.61-29.77-59.61-63.4a63.74,63.74,0,0,1,59.61-63.41L148,52c-35.35,0-64,28.45-64,63.56S112.65,179.11,148,179.11Z' />
          <path d='M211,195.29l-23.94-6.82a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59,40.62,40.62,0,0,1-47.47,1.64,40.17,40.17,0,0,1-15-18.59,1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.73,67.73,0,0,0,79.11-2.74,66.92,66.92,0,0,0,23-33.3A1,1,0,0,0,211,195.29Z' />
          <path d='M148,179.11c35.35,0,64-28.45,64-63.55S183.35,52,148,52,84,80.45,84,115.56,112.65,179.11,148,179.11Zm0-98.06a34.51,34.51,0,1,1-34.74,34.51A34.62,34.62,0,0,1,148,81.05Z' />
        </svg>
      );
    case 'archive_icon':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='white'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M17.4583 8.125C17.4583 7.71079 17.1225 7.375 16.7083 7.375C16.294 7.375 15.9583 7.71079 15.9583 8.125H17.4583ZM16.7083 14.125H17.4583H16.7083ZM14.7083 16.125V16.875V16.125ZM5.70825 16.125V16.875V16.125ZM3.70825 14.125H2.95825H3.70825ZM4.45825 8.125C4.45825 7.71079 4.12247 7.375 3.70825 7.375C3.29404 7.375 2.95825 7.71079 2.95825 8.125H4.45825ZM2.70825 4.125H1.95825H2.70825ZM2.70825 6.125H1.95825C1.95825 6.53921 2.29404 6.875 2.70825 6.875V6.125ZM17.7083 6.125V6.875C18.1225 6.875 18.4583 6.53921 18.4583 6.125H17.7083ZM12.2083 9.125H12.9583H12.2083ZM11.2083 10.125V10.875V10.125ZM9.20825 10.125V10.875V10.125ZM8.20825 9.125H7.45825H8.20825ZM9.20825 8.125V7.375V8.125ZM11.2083 8.125V7.375V8.125ZM15.9583 8.125V14.125H17.4583V8.125H15.9583ZM15.9583 14.125C15.9583 14.4565 15.8266 14.7745 15.5921 15.0089L16.6528 16.0695C17.1685 15.5538 17.4583 14.8543 17.4583 14.125H15.9583ZM15.5921 15.0089C15.3577 15.2433 15.0398 15.375 14.7083 15.375V16.875C15.4376 16.875 16.1371 16.5853 16.6528 16.0695L15.5921 15.0089ZM14.7083 15.375H5.70825V16.875H14.7083V15.375ZM5.70825 15.375C5.37673 15.375 5.05879 15.2433 4.82437 15.0089L3.76371 16.0695C4.27943 16.5853 4.97891 16.875 5.70825 16.875V15.375ZM4.82437 15.0089C4.58995 14.7745 4.45825 14.4565 4.45825 14.125H2.95825C2.95825 14.8543 3.24798 15.5538 3.76371 16.0695L4.82437 15.0089ZM4.45825 14.125V8.125H2.95825V14.125H4.45825ZM16.7083 2.375H3.70825V3.875H16.7083V2.375ZM3.70825 2.375C3.24412 2.375 2.799 2.55937 2.47082 2.88756L3.53148 3.94822C3.57836 3.90134 3.64195 3.875 3.70825 3.875V2.375ZM2.47082 2.88756C2.14263 3.21575 1.95825 3.66087 1.95825 4.125H3.45825C3.45825 4.0587 3.48459 3.99511 3.53148 3.94822L2.47082 2.88756ZM1.95825 4.125V6.125H3.45825V4.125H1.95825ZM2.70825 6.875H17.7083V5.375H2.70825V6.875ZM18.4583 6.125V4.125H16.9583V6.125H18.4583ZM18.4583 4.125C18.4583 3.66087 18.2739 3.21575 17.9457 2.88756L16.885 3.94822C16.9319 3.99511 16.9583 4.0587 16.9583 4.125H18.4583ZM17.9457 2.88756C17.6175 2.55937 17.1724 2.375 16.7083 2.375V3.875C16.7746 3.875 16.8381 3.90134 16.885 3.94822L17.9457 2.88756ZM11.4583 9.125C11.4583 9.1913 11.4319 9.25489 11.385 9.30178L12.4457 10.3624C12.7739 10.0342 12.9583 9.58913 12.9583 9.125H11.4583ZM11.385 9.30178C11.3381 9.34866 11.2746 9.375 11.2083 9.375V10.875C11.6724 10.875 12.1175 10.6906 12.4457 10.3624L11.385 9.30178ZM11.2083 9.375H9.20825V10.875H11.2083V9.375ZM9.20825 9.375C9.14195 9.375 9.07836 9.34866 9.03148 9.30178L7.97082 10.3624C8.299 10.6906 8.74412 10.875 9.20825 10.875V9.375ZM9.03148 9.30178C8.98459 9.25489 8.95825 9.1913 8.95825 9.125H7.45825C7.45825 9.58913 7.64263 10.0342 7.97082 10.3624L9.03148 9.30178ZM8.95825 9.125C8.95825 9.0587 8.98459 8.99511 9.03148 8.94822L7.97082 7.88756C7.64263 8.21575 7.45825 8.66087 7.45825 9.125H8.95825ZM9.03148 8.94822C9.07836 8.90134 9.14195 8.875 9.20825 8.875V7.375C8.74412 7.375 8.299 7.55937 7.97082 7.88756L9.03148 8.94822ZM9.20825 8.875H11.2083V7.375H9.20825V8.875ZM11.2083 8.875C11.2746 8.875 11.3381 8.90134 11.385 8.94822L12.4457 7.88756C12.1175 7.55937 11.6724 7.375 11.2083 7.375V8.875ZM11.385 8.94822C11.4319 8.99511 11.4583 9.0587 11.4583 9.125H12.9583C12.9583 8.66087 12.7739 8.21575 12.4457 7.88756L11.385 8.94822Z' />
        </svg>
      );
    case 'dropdown_icon':
      return (
        <svg
          width='15'
          height='15'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.4038 9.00098C17.2854 9.00106 18 9.71573 18 10.5973C17.9971 10.8448 17.9495 11.0881 17.8607 11.3086C17.7719 11.5291 17.6444 11.7208 17.488 11.869L12.4942 16.7905C12.3518 16.9265 12.1783 17 12 17C11.8217 17 11.6482 16.9265 11.5058 16.7905L6.512 11.869C6.35557 11.7208 6.22806 11.5291 6.13929 11.3086C6.05053 11.0881 6.00287 10.8448 6 10.5973C6 9.71516 6.71516 9.00007 7.5973 9.00015L16.4038 9.00098Z'
            fill='#424242'
          />
        </svg>
      );
    case 'expand_icon':
      return (
        <svg width='6' height='8' viewBox='0 0 6 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.652833 0.87885L3.76746 3.99348L0.652833 7.10811C0.554969 7.20609 0.5 7.33892 0.5 7.47741C0.5 7.61589 0.554969 7.74872 0.652833 7.8467C0.701081 7.89556 0.758601 7.93428 0.822017 7.9606C0.885433 7.98693 0.953468 8.00032 1.02213 7.99999C1.09079 8.00032 1.15883 7.98693 1.22224 7.9606C1.28566 7.93428 1.34318 7.89556 1.39142 7.8467L4.87535 4.36278C4.97321 4.26479 5.02818 4.13197 5.02818 3.99348C5.02818 3.85499 4.97321 3.72217 4.87535 3.62418L1.39142 0.140257C1.29236 0.0479469 1.16133 -0.00230731 1.02595 8.14175e-05C0.89056 0.00247015 0.761386 0.0573153 0.665639 0.153063C0.569891 0.24881 0.515046 0.377984 0.512657 0.51337C0.510268 0.648756 0.560523 0.779784 0.652833 0.87885Z'
            fill='#1F1F1F'
          />
        </svg>
      );
    case 'collapse_icon':
      return (
        <svg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M7.99999 1.02213C8.00032 0.953468 7.98693 0.885433 7.9606 0.822017C7.93428 0.758601 7.89556 0.701082 7.8467 0.652833C7.74872 0.554969 7.61589 0.5 7.47741 0.5C7.33892 0.5 7.20609 0.554969 7.10811 0.652833L3.99348 3.76746L0.87885 0.652833C0.779784 0.560523 0.648756 0.510268 0.51337 0.512657C0.377984 0.515046 0.24881 0.569891 0.153063 0.665639C0.0573153 0.761386 0.00247015 0.89056 8.14175e-05 1.02595C-0.00230731 1.16133 0.0479469 1.29236 0.140257 1.39143L3.62418 4.87535C3.72217 4.97322 3.85499 5.02818 3.99348 5.02818C4.13197 5.02818 4.26479 4.97322 4.36278 4.87535L7.8467 1.39143C7.89556 1.34318 7.93428 1.28566 7.9606 1.22224C7.98693 1.15883 8.00032 1.09079 7.99999 1.02213Z'
            fill='#1F1F1F'
          />
        </svg>
      );
    case 'small_folder_shared':
      return (
        <svg
          width='18'
          height='18'
          viewBox='0 0 20 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M4.08366 3.33331C3.66365 3.33331 3.26084 3.50016 2.96384 3.79716C2.66685 4.09415 2.5 4.49696 2.5 4.91697V14.4189C2.5 14.8389 2.66685 15.2417 2.96384 15.5387C3.26084 15.8357 3.66364 16.0026 4.08366 16.0026H6.46412V14.9468H4.08366C3.94365 14.9468 3.80938 14.8912 3.71039 14.7922C3.61139 14.6932 3.55577 14.5589 3.55577 14.4189V4.91697C3.55577 4.77697 3.61139 4.6427 3.71039 4.5437C3.80938 4.4447 3.94365 4.38908 4.08366 4.38908H6.72309C6.80504 4.38908 6.88587 4.40817 6.95917 4.44482C7.03246 4.48147 7.09622 4.53468 7.1454 4.60024L8.41232 6.28947C8.51202 6.4224 8.66848 6.50063 8.83463 6.50063H15.6971C15.8372 6.50063 15.9714 6.55625 16.0704 6.65524C16.1694 6.75424 16.225 6.88851 16.225 7.02851V9.53846H17.2808V7.02851C17.2808 6.6085 17.114 6.20569 16.817 5.9087C16.52 5.61171 16.1172 5.44486 15.6971 5.44486H9.09857L7.99001 3.96678C7.8425 3.77009 7.65122 3.61045 7.43132 3.5005C7.21142 3.39055 6.96894 3.33331 6.72309 3.33331H4.08366Z'
            fill='#474747'
          />
          <path
            d='M10.2917 12.3333C11.3042 12.3333 12.125 11.5125 12.125 10.5C12.125 9.48746 11.3042 8.66665 10.2917 8.66665C9.27914 8.66665 8.45833 9.48746 8.45833 10.5C8.45833 11.5125 9.27914 12.3333 10.2917 12.3333Z'
            fill='#474747'
          />
          <path
            d='M14.837 13C15.6654 13 16.337 12.3284 16.337 11.5C16.337 10.6716 15.6654 9.99998 14.837 9.99998C14.0086 9.99998 13.337 10.6716 13.337 11.5C13.337 12.3284 14.0086 13 14.837 13Z'
            fill='#474747'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.17035 13.8787C7.60774 14.4413 7.29167 15.2043 7.29167 16H13.2917V15.9911H17.2917C17.2917 15.3428 17.0107 14.721 16.5106 14.2626C16.0105 13.8042 15.3322 13.5466 14.625 13.5466C13.9178 13.5466 13.1838 14.2626 13.1838 14.2626C13.1838 14.2626 13.0491 14.3786 12.9247 14.5623C12.7888 14.3133 12.6171 14.0828 12.413 13.8787C11.8504 13.316 11.0873 13 10.2917 13C9.49602 13 8.73296 13.316 8.17035 13.8787ZM13.2917 15.9911C12.4944 15.4895 12.6914 14.9068 12.9247 14.5623C13.0433 14.7795 13.1347 15.0108 13.1966 15.2507C13.2585 15.4906 13.2909 15.7392 13.2917 15.9911Z'
            fill='#474747'
          />
          <path
            d='M12.9247 14.5623C12.6914 14.9068 12.4944 15.4895 13.2917 15.9911C13.2909 15.7392 13.2585 15.4906 13.1966 15.2507C13.1347 15.0108 13.0433 14.7795 12.9247 14.5623Z'
            fill='#474747'
          />
        </svg>
      );
    case 'small_folder':
      return (
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 11'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.402 4.09775C14.2478 3.94359 14.0583 3.8665 13.8333 3.8665H7.83325L6.63325 2.6665H2.63325C2.40825 2.6665 2.21867 2.74359 2.0645 2.89775C1.91034 3.05192 1.83325 3.2415 1.83325 3.4665V11.8665C1.83325 12.0915 1.91034 12.2811 2.0645 12.4353C2.21867 12.5894 2.40825 12.6665 2.63325 12.6665H13.8333C14.0583 12.6665 14.2478 12.5894 14.402 12.4353C14.5562 12.2811 14.6332 12.0915 14.6332 11.8665V4.6665C14.6332 4.4415 14.5562 4.25192 14.402 4.09775ZM6.21904 3.6665H2.83325V11.6665H13.6332V4.8665H7.41904L6.21904 3.6665Z'
            fill='#474747'
          />
        </svg>
      );
    default:
      break;
  }

  return null;
}
